import classNames from 'classnames';
import React from 'react';
import styles from "./skeleton.module.css";

/** The Skeleton component. Used to mimic the scaffolding of a piece of content while it loads. */
export const Skeleton = _ref => {
  let {
    className,
    children,
    ...htmlProps
  } = _ref;
  return /*#__PURE__*/React.createElement("div", Object.assign({}, htmlProps, {
    className: classNames(styles.skeleton, className)
  }), children, /*#__PURE__*/React.createElement("div", {
    className: styles.shine
  }));
};
//# sourceMappingURL=skeleton.react-component.js.map